// extracted by mini-css-extract-plugin
export default {"body":"PaymentModal_body__7OzcK","background":"PaymentModal_background__pNw4J"};